import React from 'react'

const TagsViewResult = ({result}) => {
  const tags = result?.tags || []

  return (
    <div className="mt-4 overflow-x-auto">
      <table className="table table-zebra w-full">
        <thead>
          <tr className="bg-base-200">
            <th className="font-bold">Value</th>
            <th className="font-bold">Category</th>
            <th className="font-bold">Confidence</th>
          </tr>
        </thead>
        <tbody>
          {tags.map((tag, index) => (
            <tr key={index}>
              <td>{tag.value || '-'}</td>
              <td className="capitalize">{tag?.category || '-'}</td>
              <td>{tag?.confidence ? `${(tag?.confidence)}%` : '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default TagsViewResult